export interface EffectiveRate {
    value: string;
    isFixed: boolean;
}

/** Fixed order rate always wins; each screen decides separately what locks it. */
export function resolveEffectiveRate(
    fixed: string | null | undefined,
    fallback?: string | null,
): EffectiveRate {
    return {
        value: fixed ?? fallback ?? "",
        isFixed: fixed != null,
    };
}
